import styled, { css } from 'styled-components';
import {
    ANIMATION_CURVE,
    ANIMATION_DURATION,
    Card,
    getSpacingToken,
    getToken,
    MEDIA_QUERY,
    Stack,
    StackItem,
} from '@optimus-web/core';
import { FilterSidebarWrapperProps } from './types';

const width = '444px';

export const FilterSidebarWrapper = styled(Card).attrs<FilterSidebarWrapperProps>((props) => ({
    inert: props.show ? undefined : 'true',
}))<FilterSidebarWrapperProps>`
    position: relative;
    flex-shrink: 0;
    height: 100%;
    width: ${width};
    transition: all ${ANIMATION_CURVE.default} ${ANIMATION_DURATION.default}ms;
    margin-right: ${(props) =>
        !props.show ? `calc(-${width} + -${props.hideOffset ? getSpacingToken(props.hideOffset)(props) : 0}px)` : '0'};
    overflow: hidden;

    ${MEDIA_QUERY.tabletMax} {
        width: 100%;
        margin-right: ${(props) =>
            !props.show ? `calc(-100% + -${props.hideOffset ? getSpacingToken(props.hideOffset)(props) : 0}px)` : '0'};
        flex: 0 0 auto;
    }
`;

export const FilterSidebarHeader = styled(Stack)<{ hasScrollBar?: boolean }>`
    padding: ${getSpacingToken('300')}px;
    border-bottom: ${getToken('borderWidth100')}px solid transparent;
    ${({ hasScrollBar, theme }) =>
        hasScrollBar &&
        css`
            border-color: ${getToken('borderStaticSecondary')({ theme })};
            background-color: ${getToken('backgroundStaticRaised')({ theme })};
        `};
`;

export const FilterSidebarContent = styled(StackItem)`
    overflow-y: auto;
    padding: ${getSpacingToken('100')}px ${getSpacingToken('300')}px;
`;

export const FilterSidebarActions = styled(Stack)<{ hasScrollBar?: boolean }>`
    padding: calc(${getSpacingToken('300')}px - ${getToken('borderWidth100')}px) ${getSpacingToken('300')}px
        ${getSpacingToken('300')}px;
    border-top: ${getToken('borderWidth100')}px solid transparent;
    ${({ hasScrollBar, theme }) =>
        hasScrollBar &&
        css`
            border-color: ${getToken('borderStaticSecondary')({ theme })};
            background-color: ${getToken('backgroundStaticRaised')({ theme })};
        `};
`;
